import axios from '@axios'

export default {
  list({ commit }, queryParams) {
    const params = {}
    const allowedParams = ['dc_type', 'direction', 'limit', 'offset', 'organization', 'period_id', 'search']

    allowedParams.forEach(param => {
      if (queryParams[param] !== undefined && queryParams[param] !== null && queryParams[param] !== '') {
        params[param] = queryParams[param]
      }
    })

    return new Promise((resolve, reject) => {
      axios.get('/apply-documents/scientific-topics/', { params })
        .then(response => {
          commit('LIST', response.data.results)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
}
